import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LikeButton.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
